import { useStyles } from '../../styles';
import { useLocation, useHistory } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import KenLoader from '../../globalComponent/KenLoader';
import { AuthContext } from '../../../../Helpers/Contexts/authContext';
import { getRegisterEvents } from '../../../../Utils/apiService';
import { Box, Button, Grid, Paper } from '@mui/material';
import { filter } from 'lodash';
import EventActionHeader from '../../components/EventActionHeader';
import NoEvents from '../../components/NoEvents';
import AppFilter from '../../globalComponent/AppFilter';
import { filterDependencyArray } from '../../utils/eventFilterForm';
import KenColors from '../../utils/kenColors';
import { Typography } from '@mui/material';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { AllEvents as IAllEvents, AppFilterFields } from '../../utils/interfaces';
import { AppFilterFunction } from '../../utils/helpers';
import { getEventsData } from '../../../../Utils/apiService';
import moment from 'moment';
import EventActionHeaderMobile from '../../components/EventActionHeaderMobile';

export const createRecord = (items: any) => {
  return {
    ...items,
    Id: items?.Id,
    name: items?.eventTitle,
    title: items?.eventTitle,
    startTime: items?.startDate,
    endTime: items?.endDate,
    mode: 'Hybrid',
    fee: null,
    location: null,
    eventLength: 'One day',
    noOfParticipant: items?.maximumNumberofParticipants,
    description: items?.description,
    secondaryDescription: items?.agenda,
    deliveryLanguage: items?.languageOfDelivery,
    coverImage: items?.coverImage?.imageUrl,
    suitableFor: 'Faculty',
    duration: items?.duration,
  };
};
const AllEvents : React.FunctionComponent = () => {
  const classes = useStyles();
  const { search } = useLocation();
  const navigate = useHistory();
  const {
    state: { user },
  } = useContext(AuthContext);
  const userData = user as any;
  const [loading, setLoading] = useState<boolean>(false);

  const [filter, setFilter] = useState<boolean>(false);
  const [filterData, setFilterData] = useState<AppFilterFields>({});
  const [eventsData, setEventsData] = useState<IAllEvents>({
    events: { featured: [], upcoming: [] },
    registedredEvents: [],
    filteredEvents: { featured: [], upcoming: [] },
    postedEvent: [],
    pastEvents: [],
  });
  console.log(eventsData, 'eventsDataeventsDataeventsDataeventsDataeventsData');
  
  const ismobile = window.innerWidth <= 600;

  const handleFilterOpen = () => {
    setFilter(!filter);
  };

  const handleFilterCancellation = () => {
    handleFilterOpen();
  };

  const handleFilterCells = (data: string, key: string) => {
    setFilterData({ ...filterData, [key]: data });
  };

  const handleFiltering = () => {
    handleFilterOpen();
  };

  const handleFilerRemove = (key: string) => {
    const sampleFilters = { ...filterData };
    delete sampleFilters[key];
    setFilterData(sampleFilters);
  };

  const handleClearAllFilters = () => {
    setFilterData({});
  };

  useEffect(() => {
    setLoading(true);
    getEventsData()
      .then(async (res) => {
        if (res?.result && typeof res.result === 'string') {
          try {
            const datasss = JSON.parse(res.result);
            console.log('datasss', datasss);

            const data = JSON.parse(res?.result).map((items: any) => {
              items['duration'] = items?.endDate && items.startDate ? moment(items?.endDate).diff(items.startDate, 'days') : 0;
              return items;
            });

            const upcomingEvents = data
              ?.filter((items: any) => {
                return items?.isUpcoming === true && items?.isApproved === true;
              })
              .map((items: any) => {
                return createRecord(items);
              });

            const featuredEvents = data
              ?.filter((items: any) => {
                return items?.isUpcoming === false && items?.ispast === false;
              })
              .map((items: any) => {
                return createRecord(items);
              });

            const pastEvents = data
              ?.filter((items: any) => {
                return items?.ispast === true;
              })
              .map((items: any) => {
                return createRecord(items);
              });
            // console.log('res45654', pastEvents, upcomingEvents);
            setEventsData({
              events: { featured: featuredEvents, upcoming: upcomingEvents },
              filteredEvents: { featured: featuredEvents, upcoming: upcomingEvents },
              registedredEvents: upcomingEvents,
              postedEvent: [],
              pastEvents: pastEvents,
            });
            setLoading(false);
          } catch (error) {
            console.error('Error parsing events data:', error);
            setEventsData({
              events: { featured: [], upcoming: [] },
              filteredEvents: { featured: [], upcoming: [] },
              registedredEvents: [],
              postedEvent: [],
              pastEvents: [],
            });
            setLoading(false);
          }
        } else {
          setEventsData({
            events: { featured: [], upcoming: [] },
            filteredEvents: { featured: [], upcoming: [] },
            registedredEvents: [],
            postedEvent: [],
            pastEvents: [],
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.error(err);
      });
  }, []);

  useEffect(() => {
    const data = AppFilterFunction({ data: [...eventsData.events.featured, ...eventsData.events.upcoming], filterData: filterData });
    const featured: Array<any> = [];
    const upcoming: Array<any> = [];
    data?.forEach((items: any) => {
      if (items?.isUpcoming === false && items?.ispast === false) {
        featured.push({ ...items });
      } else {
        upcoming.push({ ...items });
      }
    });
    setEventsData({ ...eventsData, filteredEvents: { featured: [...featured], upcoming: [...upcoming] } });
  }, [filterData]);

  return (
    <>
      {loading && (eventsData.events.featured?.length === 0 || eventsData.events.upcoming?.length === 0) ? (
        <KenLoader />
      ) : (
        <Grid
          item
          container
          spacing={2}
          xs={12}
          lg={12}
          sx={{
            height: '90vh',
            '@media (min-width: 1280px) and (max-width: 1300px)': {
              height: '85vh',
            },
          }}
          className="scrollbar-cusgrayHeader"
        >
          <Grid item xs={12} md={7} lg={9} xl={9}>
            {eventsData.filteredEvents.upcoming?.length === 0 ? (
              <NoEvents
                filterData={filterData}
                handleFilerRemove={(key) => {
                  handleFilerRemove(key);
                }}
                handleFilterOpen={() => {
                  handleFilterOpen();
                }}
              />
            ) : (
              <Paper
                className={`scrollbar-cusgray ${classes.cardContainer}`}
                sx={{
                  height: {
                    xs: 'auto !important',
                    sm: '82.5vh !important',
                  },
                }}
              >
                <Box className="w-100 d-flex flex-column" gap={'20px'}>
                  {eventsData.filteredEvents.upcoming?.length > 0 && (
                    <EventActionHeaderMobile
                      eventsData={eventsData.filteredEvents.upcoming}
                      filterData={filterData}
                      title="Upcoming Events"
                      handleFilerRemove={(key: any) => {
                        handleFilerRemove(key);
                      }}
                      handleFilterOpen={handleFilterOpen}
                      filterButtonDisable={eventsData.filteredEvents.upcoming?.length > 0}
                    />
                  )}
                </Box>
               {/* <Button
                  style={{ textTransform: 'capitalize' }}
                  size="small"
                  onClick={() => {
                    handleFilterOpen();
                  }}
                  variant="contained"
                  startIcon={
                    <FilterAltOutlinedIcon
                      sx={{
                        fontSize: { xs: '20px', sm: '22px', md: '26px', lg: '28px' },
                        color: KenColors.ClientBlack2,
                        '@media (min-width: 1280px) and (max-width: 1300px)': {
                          fontSize: '15px',
                        },
                      }}
                    />
                  }
                  className={classes.filterBtn}
                >
                  Filters
                </Button> */}
              </Paper>
            )}
            <AppFilter
              transform={{ top: '-84%', left: '32%' }}
              filterData={filterData}
              dependencyArray={filterDependencyArray([...(eventsData.events.featured ? eventsData.events.featured : []), ...(eventsData.events.upcoming ? eventsData.events.upcoming : [])])}
              handleChange={handleFilterCells}
              handleClose={handleFilterCancellation}
              handleFilterSubmit={handleFiltering}
              open={filter}
              handleClearAll={handleClearAllFilters}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default AllEvents;
